// extracted by mini-css-extract-plugin
export default {"loading-overlay":"loading_loading-overlay__-NW6O","loading-dots":"loading_loading-dots__925Qs"};